import { DeviceGlobalStatusEnum } from "./DeviceStatus/DeviceGlobalStatusEnum";

export class InstallationStatusChange {
    id: number = -1;
    installationName: string = null;
    status: DeviceGlobalStatusEnum = DeviceGlobalStatusEnum.Unknown;
    timestamp: Date = null;
    receivedAt: Date = null;

    constructor() {}

    public parse(obj: any) {
        if (obj.Id) this.id = obj.Id;
        if (obj.InstallationName) this.installationName = obj.InstallationName;
        if (obj.Status != null && Object.values(DeviceGlobalStatusEnum).includes(obj.Status)) this.status = obj.Status;
        if (obj.Timestamp) this.timestamp = obj.Timestamp;
        if (obj.ReceivedAt) this.receivedAt = obj.ReceivedAt;
    }
}

export class InstallationStatusChangeForUI extends InstallationStatusChange {
    isNew: boolean;
    machinesSerialNumber: string[] = [];
    installationLastMessage: Date = null;
    installationAgentIP: string = null;

    public parse(obj: any) {
        super.parse(obj);
        this.isNew = obj.IsNew;
        this.machinesSerialNumber = [];
        if (obj.MachinesSerialNumber && obj.MachinesSerialNumber.length > 0)
            obj.MachinesSerialNumber.forEach((sn) => {
                this.machinesSerialNumber.push(sn);
            });
        if (obj.InstallationLastMessage) this.installationLastMessage = obj.InstallationLastMessage;
        if (obj.InstallationAgentIP) this.installationAgentIP = obj.InstallationAgentIP;
    }
}
